import React from 'react';
import { Star, Moon, Baby } from 'lucide-react';
import { motion } from 'framer-motion';
export const HeroSection = () => {
  return <section className="pt-28 pb-16 md:pt-36 md:pb-24 px-6 max-w-7xl mx-auto" data-id="element-73">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col space-y-6" data-id="element-75">
          <div className="flex items-center gap-2 bg-white/60 w-fit px-4 py-2 rounded-full shadow-sm border border-brand-lavender/20" data-id="element-76">
            <div className="flex text-brand-amber" data-id="element-77">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-78" />)}
            </div>
            <span className="text-sm font-medium text-brand-navy" data-id="element-79">
              2,847+ madres ya duermen mejor
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight" data-id="element-80">
            Recupera tus noches{' '}
            <span className="text-brand-gold italic" data-id="element-81">(y tu cordura)</span> en
            solo 72 horas:
            <span className="block text-2xl md:text-3xl mt-4 font-sans font-normal text-brand-charcoal" data-id="element-82">
              El Método de Sueño Profundo para Bebés Sensibles.
            </span>
          </h1>

          <h2 className="text-lg md:text-xl text-brand-charcoal/80 font-sans leading-relaxed" data-id="element-83">
            El primer sistema neuro-sensorial diseñado{' '}
            <strong className="text-brand-charcoal font-bold" data-id="element-84">
              para madres que han intentado todo
            </strong>{' '}
            y cuyo bebé parece "luchar" contra el sueño cada noche.
          </h2>

          <div className="pt-4" data-id="element-85">
            <a href="#pricing" className="btn-gold-3d inline-block w-full md:w-auto text-center text-white font-bold text-lg py-4 px-8 rounded-xl transition-all transform hover:-translate-y-1 active:translate-y-0 tracking-wide uppercase" data-id="element-86">
              ¡SÍ, QUIERO DORMIR OTRA VEZ!
            </a>
            <p className="text-xs text-center md:text-left text-brand-navy mt-3 flex items-center justify-center md:justify-start gap-1" data-id="element-87">
              <Moon className="w-3 h-3" data-id="element-88" /> Acceso instantáneo, incluso si son
              las 3 AM
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative" data-id="element-89">
          <div className="rounded-3xl shadow-2xl overflow-hidden relative" data-id="element-90">
            <img src="https://cdn.magicpatterns.com/uploads/jopzEmZWjC5kbiGHFxDc2U/LP_Portada.png" alt="El Método Sueño Profundo - Producto digital mostrado en múltiples dispositivos" className="w-full h-auto object-cover rounded-3xl" data-id="element-91" />
          </div>
        </motion.div>
      </div>
    </section>;
};